import MailIcon from '@mui/icons-material/Mail';
import PeopleIcon from '@mui/icons-material/People';
import { i18n } from 'i18n';
import makePage from 'modules/makePage';
import lazyWithSuspense from 'modules/lazyWithSuspense';
import Page from 'modules/Page';
import withNavigation from '../../withNavigation';
import * as constants from './constants';

const InvitationsPage = lazyWithSuspense(() => import('./InvitationsPage'));
const UsersPage = lazyWithSuspense(() => import('./UsersPage'));

const page: Page = {
  title: constants.TITLE,
  mainMenuConfig: {
    group: 'Admin',
    iconComponent: PeopleIcon,
  },
  routeProps: {
    path: constants.ROUTE_PATH,
  },
  navigationPath: constants.USER_ACCOUNTS_ROUTE_PATH,
  admin: true,
  component: withNavigation({
    Component: makePage({
      titleFn: () => i18n._(constants.TITLE),
    }),
    defaultRoute: constants.USER_ACCOUNTS_ROUTE_PATH,
    pageNavigation: [
      {
        title: i18n._(constants.USER_ACCOUNTS_TITLE),
        iconComponent: PeopleIcon,
        routeProps: {
          path: constants.USER_ACCOUNTS_ROUTE_PATH,
        },
        Component: UsersPage,
      },
      {
        title: i18n._(constants.INVITATION_TITLE),
        iconComponent: MailIcon,
        routeProps: {
          path: constants.INVITATION_ROUTE_PATH,
        },
        Component: InvitationsPage,
      },
    ],
  }),
};

export default page;
